export const AUTH_TOKEN = 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJhZGl0aXNAYnJpY2tuYm9sdC5jb20iLCJpZCI6IjVmZGM5MWJlMDkwM2ZiMjY2ODYzY2U4OCIsImV4cCI6MTY1NzE3NTcwOCwiaWF0IjoxNjU3MDAyOTA4fQ.kT8YRcEi_6sgThgWhJig_4PA0QvR40KZTl4i7sEPu9HqUub17JiShtjgZ3bWY9nT2f_XMVZuWiNWkiLcYqC_6w';

const statuses = ['MISSED', 'CLOSED', 'TO_BE_VERIFIED', 'OPEN', 'MISSED_BY_CONTRACTOR', 'RE_OPENED']
export const getStatusStyle = (status) => {
    switch (status) {
        case 'MISSED': return {
            color: '#9A1111',
            backgroundColor: '#f5e7e7',
        };
        case 'CLOSED': return {
            color: '#4CD3AB',
            backgroundColor: '#4cd3ab1a',
        };
        case 'TO_BE_VERIFIED': return {
            color: '#30BCF8',
            backgroundColor: '#30bcf81a',
        };
        case 'OPEN': return {
            color: '#F3BF53',
            backgroundColor: '#f3bf531a',
        };
        case 'MISSED_BY_CONTRACTOR': return {
            color: '#9A1111',
            backgroundColor: '#f5e7e7',
        };
        case 'RE_OPENED': return {
            color: '#F12929',
            backgroundColor: '#f129291a',
        }
        default: return {
            color: '#9A1111',
            backgroundColor: '#f5e7e7',

        }
    }
}
export const getStatusLabel = (status) => {
    switch (status) {
        case 'MISSED': return {
            text: 'Missed',
        };
        case 'CLOSED': return {    
            text: 'Closed',
        };
        case 'TO_BE_VERIFIED': return {    
            text: 'To Be Verified',
        };
        case 'OPEN': return {    
            text: 'Open',
        };
        case 'MISSED_BY_CONTRACTOR': return {    
            text: 'Missed',
        };
        case 'RE_OPENED': return {    
            text: 'Re-Opened',
         }
        default: return {
            text: 'Missed',
        }
    }
}